import React, { useCallback } from 'react';
import Countdown from 'antd/lib/statistic/Countdown';
import { Button, FieldSet } from '@alfa-retail-react/components';
import { observer } from 'mobx-react';

import { SmsSignFormStore } from 'app/logic/pages/sign/SmsSignFormStore';
import { OtpConfirmationStatus } from 'app/model/OtpConfirmationStatus';

interface MsCountdownProps {
    prefix: string;

    value: number;

    format: string;

    onFinish: () => void;
}

const MsCountdown = React.memo((props: MsCountdownProps) => {
    return (
        <Countdown
            prefix={props.prefix}
            value={Date.now() + props.value}
            format={props.format}
            onFinish={props.onFinish}
        />
    );
});

export interface LinkStatesProps {
    formStore: SmsSignFormStore;

    timer: 'initial' | boolean;

    setTimer: (value: boolean) => void;

    clearFieldErrors: () => void;
}

/**
 * Компонент состояния ссылки.
 */
export const ActionTimer = React.memo(
    observer(
        ({ formStore, timer, setTimer, clearFieldErrors }: LinkStatesProps) => {
            const onFinishTimer = useCallback(() => {
                setTimer(false);
            }, [timer]);

            const onOtpRequested = async () => {
                await formStore.getOrderConfirmationOtp();
                if (
                    formStore.otpConfirmation.status ===
                    OtpConfirmationStatus.OK
                ) {
                    clearFieldErrors();
                }
                setTimer(true);
            };

            return (
                <FieldSet
                    className="linkStates"
                    fieldsProps={[
                        {
                            value: (
                                <MsCountdown
                                    prefix="Запросить новый код можно через "
                                    value={
                                        formStore.otpConfirmation
                                            ?.generationDelay
                                    }
                                    format="mm:ss"
                                    onFinish={onFinishTimer}
                                />
                            ),
                            isVisible:
                                timer !== false &&
                                formStore.hasGenerationAttempts,
                        },
                        {
                            value: (
                                <Button
                                    disabled={
                                        formStore.actionStateStore.isLoading
                                    }
                                    block={true}
                                    view="secondary"
                                    onClick={onOtpRequested}
                                >
                                    Запросить новый код
                                </Button>
                            ),
                            isVisible:
                                (timer === false &&
                                    !!formStore.otpConfirmation &&
                                    formStore.hasGenerationAttempts) ||
                                (!formStore.otpConfirmation &&
                                    !formStore.hasGenerationAttempts),
                        },
                    ]}
                />
            );
        },
    ),
);
